import Blog_Details from "./blog_details";
import Blog_Slider from "./blog_slider";
import { useSelector } from "react-redux";

import Related_Blogs from "./related_blogs";
import Blog_Enquiry from "./blog_enquiry";
import SeoHead from "../ui/seoHead/seoHead";
import CTAForm from "../Cta/CtaForm";

const Blog_Details_Page = ({ blogDetailsUrl, newsDetalsApiData }) => {
  // const newsDetalsApiData = useSelector((state) => state.newsDetailsData);
  const blogSliderData = newsDetalsApiData?.top_blogs || [];
  const blog_data = newsDetalsApiData?.related_blogs || [];

  return (
    <>
      <div className="blogContent container flex flex-wrap gap-5 lg:gap-[2vw] pt-5 lg:pt-[3.5vw] justify-between items-start custom_ul ">
        <Blog_Details
          newsDetalsApiData={newsDetalsApiData}
          blogDetailsUrl={blogDetailsUrl}
        />
        <div className="w-full md:w-[30%]">
          <CTAForm dialogue={"Speak to our expert"} product_code={newsDetalsApiData?.title} type={"Blog CTA FORM"} />
          <br />
          <Blog_Slider data={blogSliderData} />
          {
            <Related_Blogs blog_data={blog_data} />
          }
        </div>
      </div>
    </>
  );
};

export default Blog_Details_Page;
